import { render } from "./EmployeeManagement.vue?vue&type=template&id=faed6dda"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__